import { render, staticRenderFns } from "./InstitutionDetailsSkeleton.vue?vue&type=template&id=11e43c3c"
import script from "./InstitutionDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./InstitutionDetailsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports